import React, { useState } from "react";
import useRolePermission from "../../customHooks/RolePermission/useRolePermission";
import "./RolePermission.css";
import { IoArrowBackCircle } from "react-icons/io5";
import { useNavigate, useParams } from "react-router";
import AlertModal from "../../components/Alert/AlertModal";
import FullPageLoading from "../../components/FullPageLoading/FullPageLoading";
import { Loader as LoaderIcon } from "react-feather";
import usePermission from "../../utils/usePermission";
import UnAuthorized from "../UnAuthorized/UnAuthorized";

const RolePermission = () => {
  const params = useParams();
  const { id } = params;

  const {
    roleData,
    selectedPermissions,
    handleModuleChange,
    handleApplicationChange,
    handlePermissionChange,
    handleChange,
    changeDetails,
    handleSubmit,
    submitLoader,
    loader,
    handleBlur,
    renderErrorMessage,
    expandedApps,
    expandedModules,
    toggleAppExpand,
    toggleModuleExpand,
  } = useRolePermission({ id });
  const navigate = useNavigate();
  const canUpdate = usePermission("ROLE_UPDATE");
  const canRead = usePermission("ROLE_READ");
  // const canUpdate = true;

  return (
    <div className="container">
      {canRead ? (
        <>
          <div className="flex justify-between">
            <div class="mainHeader">
              <h1 class="font-semibold text-lg">
                {id ? "Update Role" : "Create Role"}
              </h1>
            </div>
            <button onClick={() => navigate("/role")} className="back">
              <IoArrowBackCircle size={20} /> Back
            </button>
          </div>
          {!loader ? (
            <>
              {" "}
              <div className="roleContainer">
                <div className="role-details">
                  <h1 className="text-xl text-center">Role Details</h1>
                  <div className="form-group">
                    <label htmlFor="sName">
                      Role Name <span className="red">*</span>
                    </label>
                    <input
                      type="text"
                      name="sName"
                      id="sName"
                      value={changeDetails?.sName}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      disabled={!canUpdate}
                      placeholder="Enter Role Name"
                    />
                    {renderErrorMessage("sName") && (
                      <div className="text-left text-small  color_red inputErrorSection">
                        {renderErrorMessage("sName")}
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="sDescription">
                      Role Description <span className="red">*</span>
                    </label>
                    <textarea
                      id="sDescription"
                      name="sDescription"
                      value={changeDetails?.sDescription}
                      onBlur={handleBlur}
                      disabled={!canUpdate}
                      onChange={handleChange}
                      placeholder="Enter Plan Description"
                      rows={10}
                    ></textarea>
                    {renderErrorMessage("sDescription") && (
                      <div className="text-left text-small  color_red inputErrorSection">
                        {renderErrorMessage("sDescription")}
                      </div>
                    )}
                  </div>
                  {/* <h2>{roleData.roleDetails.name}</h2>
          <p>{roleData.roleDetails.description}</p> */}
                </div>

                <div className="permissions-tree">
                  <h1 className="text-xl text-center">Role Permissions</h1>
                  <ol className="wtree text-black">
                    {roleData?.systemPermissions?.map((app) => {
                      const appPermissionIds = app?.modules?.flatMap((mod) =>
                        mod?.modulePermissions?.map((perm) => perm.permissionId)
                      );
                      const isAppChecked = appPermissionIds?.every((id) =>
                        selectedPermissions?.includes(id)
                      );

                      return (
                        <li key={app.applicationId}>
                          <div className="flex items-center">
                            <button
                              onClick={() =>
                                toggleAppExpand(app.applicationId, app.modules)
                              }
                              className="w-4 h-4 text-xs flex items-center justify-center bg-white text-black border border-gray-400 hover:bg-gray-200 rounded transition duration-200"
                            >
                              {expandedApps[app.applicationId] ? "−" : "+"}
                            </button>
                            <label className="permission-item">
                              <input
                                type="checkbox"
                                className="w-auto"
                                checked={isAppChecked}
                                disabled={!app.modules || !canUpdate}
                                onChange={() => handleApplicationChange(app)}
                              />
                              {app.applicationName}
                            </label>
                          </div>

                          {expandedApps[app.applicationId] &&
                            app.modules?.length > 0 && (
                              <ol className="ml-6">
                                {app.modules.map((module) => {
                                  const modulePermissionIds =
                                    module?.modulePermissions?.map(
                                      (perm) => perm.permissionId
                                    );
                                  const isModuleChecked =
                                    modulePermissionIds?.every((id) =>
                                      selectedPermissions?.includes(id)
                                    );

                                  return (
                                    <li key={module.moduleId}>
                                      <div className="flex items-center">
                                        <button
                                          onClick={() =>
                                            toggleModuleExpand(module.moduleId)
                                          }
                                          className="w-4 h-4 text-xs flex items-center justify-center bg-white text-black border border-gray-400 hover:bg-gray-200 rounded transition duration-200"
                                        >
                                          {expandedModules[module.moduleId]
                                            ? "−"
                                            : "+"}
                                        </button>
                                        <label className="permission-item">
                                          <input
                                            type="checkbox"
                                            className="w-auto"
                                            checked={isModuleChecked}
                                            disabled={
                                              !module.modulePermissions ||
                                              !canUpdate
                                            }
                                            onChange={() =>
                                              handleModuleChange(module)
                                            }
                                          />
                                          {module.moduleName}
                                        </label>
                                      </div>

                                      {expandedModules[module.moduleId] && (
                                        <ol className="ml-6">
                                          {module.modulePermissions.map(
                                            (perm) => (
                                              <li key={perm.permissionId}>
                                                <label className="permission-item">
                                                  <input
                                                    type="checkbox"
                                                    className="w-auto"
                                                    disabled={!canUpdate}
                                                    checked={selectedPermissions?.includes(
                                                      perm.permissionId
                                                    )}
                                                    onChange={() =>
                                                      handlePermissionChange(
                                                        perm.permissionId
                                                      )
                                                    }
                                                  />
                                                  {perm.permissionName}
                                                </label>
                                              </li>
                                            )
                                          )}
                                        </ol>
                                      )}
                                    </li>
                                  );
                                })}
                              </ol>
                            )}
                        </li>
                      );
                    })}
                  </ol>
                </div>

                {/* <div className="debug">
          <h3>Changes:</h3>
          <p>✅ Added Permissions: {JSON.stringify(addedPermissions)}</p>
          <p>❌ Removed Permissions: {JSON.stringify(removedPermissions)}</p>
        </div> */}
                <div className="w-full col-span-2 text-end fixedBtn">
                  {submitLoader ? (
                    <button
                      className="save-button"
                      style={{ width: "100px" }}
                      disabled={submitLoader}
                    >
                      <LoaderIcon size={20} className="indicator" />
                    </button>
                  ) : (
                    <button
                      type="submit"
                      className="save-button"
                      disabled={submitLoader || !canUpdate}
                      onClick={handleSubmit}
                    >
                      Save
                    </button>
                  )}
                  {!canUpdate && (
                    <span className="red mx-4">
                      * You don't have permission to edit roles. Please contact
                      the administrator.
                    </span>
                  )}
                </div>
              </div>
            </>
          ) : (
            <>
              <FullPageLoading />
            </>
          )}
        </>
      ) : (
        <UnAuthorized />
      )}
    </div>
  );
};

export default RolePermission;
